import type { GetPasskeyAuthenticationOptionsResponse } from '@dynamic-labs/sdk-api-core';
import type { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';

export type GetPasskeyAuthenticationOptionsParams = {
  relatedOriginRpId?: string;
};

export const getPasskeyAuthenticationOptions = async (
  { relatedOriginRpId }: GetPasskeyAuthenticationOptionsParams = {},
  client: DynamicClient
): Promise<PublicKeyCredentialRequestOptionsJSON> => {
  const core = getCore(client);

  const apiClient = createApiClient({}, client);

  const options: GetPasskeyAuthenticationOptionsResponse =
    await apiClient.getPasskeyAuthenticationOptions({
      environmentId: core.environmentId,
      relatedOriginRpId,
    });

  return options as PublicKeyCredentialRequestOptionsJSON;
};
